// src/helpers/Global.js

export const Global = {
  url: "https://gruposil.wemotion.es/api/",
  appName: "SIL Gestión",
  loginPrimary: "dni", // "mail" o "dni"
  rango_metros: 1000,
  partes_trabajo: "no",
  silcontrol: "si",
  mi_calendario: "no"
};
